import { DateTime } from 'luxon';
import { DeliveryProvider, OrderMethod } from '../../services/exports/Constants';
import { Button } from 'antd';
import React from 'react';
import { useHelpers } from '../../providers/HelpersProvider';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import OrderHelpers from '../../services/helpers/OrderHelpers';

export default function OrderTimeChangeInput({ order, preparationTime, setPreparationTime }) {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Order:OrderTimeChangeInput' });

  const { formatTime } = useHelpers();

  const { company } = useSelector((state) => state.company);
  const step = company?.order_approval_time_step ?? 10;
  const isInitialStep = preparationTime - step <= 0;

  const newPickupTime = DateTime.fromISO(order.paid_at)
    .plus({ minutes: preparationTime + 1 })
    .startOf('minute');

  const minusButtonDisabled =
    isInitialStep ||
    (order.scheduled_for && preparationTime <= order.estimated_preparation_time) ||
    (order.method === OrderMethod.Delivery &&
      order.delivery_provider !== DeliveryProvider.Standalone &&
      preparationTime === order.estimated_preparation_time);

  return (
    <div className="grid grid-cols-3 gap-4">
      <div>
        <Button
          disabled={minusButtonDisabled}
          onClick={() => setPreparationTime((current) => current - step)}
          className="size-full"
        >
          - {step} min
        </Button>
      </div>
      <div className="space-y-xs">
        <h6 className="text-center text-sm">{t(`labels.${OrderHelpers.copyMethod(order)}_time`)}</h6>
        <p className="text-center">
          {newPickupTime.hasSame(DateTime.local(), 'day') ? t('labels.today') : newPickupTime.toFormat('cccc, dd LLL')}
        </p>
        <p className="font-medium text-center">{formatTime(newPickupTime)}</p>
      </div>
      <div>
        <Button onClick={() => setPreparationTime((current) => current + step)} className="size-full">
          + {step} min
        </Button>
      </div>
    </div>
  );
}
